import React,{useState} from 'react';
import { NavLink } from 'react-router-dom';
import {AiOutlineMenu,AiOutlineClose} from 'react-icons/ai';


const Header = () => {
  let [toggle,setToggle]= useState(false)
  return (
   <>
            <div className='bg-indigo-700 p-4 '>
        <nav className='mx-w-[1240px] mx-5 flex justify-between items-center shadow-white shadow-lg p-5'>
            <h2 className='text-2xl text-white'>Logo Main</h2>
            { 
              toggle?
              <AiOutlineClose onClick={()=>{setToggle(!toggle)}} className='md:hidden block text-white text-2xl' />
            :
              <AiOutlineMenu onClick={()=>{setToggle(!toggle)}}  className='md:hidden block text-white text-2xl' />

            }
            <ul className=' hidden md:flex '>
                <li className='pl-[10px] text-xl text-white'><NavLink to={'/'} className='hover:text-yellow-600 hover:underline         hover:underline-offset-8'>Home</NavLink></li>
                <li className='pl-[10px] text-xl text-white'><NavLink to={'about'} className='hover:text-yellow-600 hover:underline     hover:underline-offset-8'>About</NavLink></li>
                <li className='pl-[10px] text-xl text-white'><NavLink to={'contact'} className='hover:text-yellow-600 hover:underline   hover:underline-offset-8'>Contact</NavLink></li>
                <li className='pl-[10px] text-xl text-white'><NavLink to={'skills'} className='hover:text-yellow-600 hover:underline    hover:underline-offset-8'>Skills</NavLink></li>
            </ul>

            {/*  */}
            <ul className={`md:hidden flex-cols  top-[60px] ${toggle?  'left-[0px]':'left-[-1500px]'} w-full fixed h-[500px] mt-12 bg-indigo-300 duration-500 text-white 
            `}>
                <li className='ml-10 py-5  text-2xl text-black'><NavLink to={'/'} className='hover:text-yellow-600 hover:underline hover:underline-offset-8'>Home</NavLink></li>
                <li className='ml-10 py-5  text-2xl text-black'><NavLink to={'about'} className='hover:text-yellow-600 hover:underline hover:underline-offset-8'>About</NavLink></li>
                <li className='ml-10 py-5  text-2xl text-black'><NavLink to={'contact'} className='hover:text-yellow-600 hover:underline hover:underline-offset-8'>Contact</NavLink></li>
                <li className='ml-10 py-5  text-2xl text-black'><NavLink to={'skills'} className='hover:text-yellow-600 hover:underline hover:underline-offset-8'>Skills</NavLink></li>
            </ul>
        </nav>


        </div>
   </>
  )
}

export default Header